<template>
	<el-config-provider :locale="locale" :button="buttonConfig" :size="assemblySize">
		<router-view></router-view>
	</el-config-provider>
</template>
<script setup lang="ts">
import { useElconfig } from '@/hooks/useElConfig'
const { buttonConfig, assemblySize, locale } = useElconfig()
</script>
<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
